import { Image, ImageProps, useColorModeValue } from '@chakra-ui/react';
import { getAsset } from '@pelicargo/tenants';

type Props = ImageProps;

export const PelicargoLogo = ({ ...rest }: Props) => {
  const logo = useColorModeValue(getAsset('brand/brand-light.svg'), getAsset('brand/brand-dark.svg'));

  return <Image src={logo} {...rest} alt="Brand" />;
};
